import React from "react";
import { useTranslation } from "react-i18next";
import { StyledHistoryStatus } from "./BetHistoryStyle";

const BetSlipList = ({ selection }) => {
  const { t } = useTranslation("General")
  return (
    <React.Fragment>
      <div className="d-flex justify-content-between align-items-center pt-2 px-2 border-info border-top">
        <div className="w-50">
          <div className=" text-black">
            <div>
              {selection.selectedMarket.marketId === 4 && (
                <span>
                  {selection.selectedMarket.selectedOutCome.outcomeName ===
                    "12" ? (
                    <span>
                      {t(`${selection.homeTeam}`)} {t("or")} {t(`${selection.awayTeam}`)}
                    </span>
                  ) : (
                    <span>
                      {selection.selectedMarket.selectedOutCome.outcomeName ===
                        "1X" ? (
                        <span>{t(`${selection.homeTeam}`)} {t("Draw")}</span>
                      ) : (
                        <span>{t(`${selection.awayTeam}`)} {t("Draw")}</span>
                      )}
                    </span>
                  )}
                </span>
              )}
            </div>
            <div>
              {selection.selectedMarket.marketId === 1 && (
                <span>
                  {selection.selectedMarket.selectedOutCome.outcomeName ===
                    "1" ? (
                    <span>{t(`${selection.homeTeam}`)}</span>
                  ) : (
                    <span>
                      {selection.selectedMarket.selectedOutCome.outcomeName ===
                        "X" ? (
                        <span>{t("Draw")}</span>
                      ) : (
                        <span>{t(`${selection.awayTeam}`)}</span>
                      )}
                    </span>
                  )}
                </span>
              )}
            </div>
            <div>
              {(selection.selectedMarket.marketId === 2 ||
                selection.selectedMarket.marketId === 3 ||
                selection.selectedMarket.marketId === 6 ||
                selection.selectedMarket.marketId === 7) && (
                  <span>
                    {t(`${selection.selectedMarket.selectedOutCome.outcomeName}`)}{" "}
                    {selection.selectedMarket.selectedOutCome.outcomeValue > 0 &&
                      selection.selectedMarket.selectedOutCome.outcomeValue}
                  </span>
                )}
            </div>
          </div>
          <div className="fw-normal">{t(`${selection.selectedMarket.marketName}`)}</div>
        </div>
        <StyledHistoryStatus className="">
          <span>
            {selection.selectedMarket.selectedOutCome.odds.toFixed(2)}
          </span>
          <span
            className={`p-1 rounded card-footer ms-2 
                        ${selection.status === "SETTLED" ||
                selection.status === "WON"
                ? "bg-success text-white"
                : selection.status === "OPEN"
                  ? "bg-warning text-dark"
                  : "bg-secondary text-white"
              }`}
          >
            {t(`${selection.status}`)}
          </span>
        </StyledHistoryStatus>
      </div>
      <div className="fw-normal px-2 pb-2">
        {t(`${selection.homeTeam}`)} {t("VS")} {t(`${selection.awayTeam}`)}{" "}
        {selection.scoreLine && <b>[{selection.scoreLine}]</b>}
      </div>
    </React.Fragment>
  );
};
export default BetSlipList;
